/* eslint-disable camelcase */
import type { Maybe, VideoAssetType, VisualBynderType } from "types"
import type { Nullable } from "utils/types"
import type { GalleryAssetType } from "./ProductGalleryV2"

export const getImageSrc = (
  image: Nullable<VisualBynderType>,
  isMobile: boolean
): string => {
  if (!image) return ""
  const { thumbnails } = image
  if (!thumbnails) return ""

  const { size_460, size_webimage, size_OTF_BETA } = thumbnails
  const desktopImage = size_webimage ?? size_OTF_BETA ?? ""

  if (isMobile) {
    return size_460 ?? desktopImage
  }

  return desktopImage
}

export const sortMedia = (
  videos: Maybe<VideoAssetType>[],
  images: Maybe<VisualBynderType>[]
): GalleryAssetType[] => {
  const media: GalleryAssetType[] = [...images]
  videos.forEach((video) => {
    if (typeof video?.position !== "number" || video?.position < 0) return
    media.splice(video.position, 0, video)
  })

  return media
}

export const isVideoType = (data: GalleryAssetType): data is VideoAssetType => {
  return Boolean((data as VideoAssetType)?.videoType)
}

export const isTouchDevice = () => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0
}
